import React, { useEffect, useState } from 'react';
import { getAccessToken } from "../../services/authApi";
import { getUserDetails, getTpoSettingsAllBasicInfo } from "../../services/userApi";
import { getChannelSupport } from '../../utils/organizationConfigUtil';

const ContactUs = () => {
    const [channelTypes, setChannelTypes] = useState([]);

    useEffect(() => {
        if (window.elli && window.elli.script && window.elli.script.guest) {
            window.elli.script.guest.create();
            initializeAuthObject();
        }
    }, []);

    const initializeAuthObject = async () => {
        try {
            window.elli.script.getObject("tpoApplication").then(async function (tpoApplicationObject) {
                try {
                    const authObject = await window.elli.script.getObject("auth");
                    const authCode = await authObject.createAuthCode();
                    const token = await getAccessToken(authCode);
                    if (token) {
                        await authObject.getUser().then(async function (user) {
                            try {
                                const userDetails = await getUserDetails(token, user.id);
                                const orgId = userDetails?.organization?.entityId;
                                const tpoSettings = await getTpoSettingsAllBasicInfo(token, orgId);
                                const channels = tpoSettings?.companyDetails?.channels ?? [];
                                setChannelTypes(channels);
                            } catch (e) {
                                setChannelTypes(["Broker"]);
                            }
                        });
                    }
                } catch (e) {
                    setChannelTypes(["Broker"]);
                }
            });
        } catch (e) {
            setChannelTypes(["Broker"]);
        }
    };

    // Render support info based on channel

    const SupportDesk = ({ desk, style }) => (
        <div style={style}>
            <div style={{ fontWeight: 'bold' }} className='lenderkey-header'>{desk.title}</div>
            <div className='contact-us'>Phone: {desk.phone}</div>
            <div className='contact-us'>Email: {desk.email}</div>
        </div>
    );

    const renderSupport = () => {
        // Always show Wholesale first if present, then Correspondent if both
        const hasWholesale = (Array.isArray(channelTypes) && channelTypes.includes("Broker")) || channelTypes === "Broker";
        const hasCorrespondent = (Array.isArray(channelTypes) && channelTypes.includes("Correspondent")) || channelTypes === "Correspondent";

        const wholesale = hasWholesale ? getChannelSupport('wholesale') : null;
        const correspondent = hasCorrespondent ? getChannelSupport('correspondent') : null;

        // Both channels: show both, left/right aligned
        if (wholesale && correspondent) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    padding: '32px 0',
                    margin: '32px auto',
                    maxWidth: 700,
                    width: '100%'
                }}>
                    <SupportDesk desk={wholesale} style={{ flex: 1, textAlign: 'left', paddingLeft: 24 }} />
                    <SupportDesk desk={correspondent} style={{ flex: 1, textAlign: 'left', paddingRight: 24 }} />
                </div>
            );
        }
        // Only Correspondent
        if (correspondent) {
            return (
                <SupportDesk
                    desk={correspondent}
                    style={{ padding: '32px 0', margin: '20px 50px', maxWidth: 350, textAlign: 'left', paddingLeft: 24 }}
                />
            );
        }
        // Only Wholesale (default)
        if (wholesale) {
            return (
                <SupportDesk
                    desk={wholesale}
                    style={{ padding: '32px 0px', margin: '20px 20px', maxWidth: 350, textAlign: 'left', paddingLeft: 24 }}
                />
            );
        }
    };

    return <div>{renderSupport()}</div>;
};

export default ContactUs;
